export default "__VITE_ASSET__DMR1brt9__"